import { Space, Table, Tooltip } from "antd"
import { toast } from "react-toastify";

const TableTokens = ({data}) => {
    const columns = [
        // {
        //     title: 'ID',
        //     dataIndex: 'id',
        //     key: 'id',
        //     width: 200,
        // },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            width: 200,
        },
        {
            title: 'Token',
            dataIndex: 'value',
            key: 'value',
            width: 240,
            render: (_, record) => (
                <Tooltip placement="top" title={"Copy"}>
                    <a onClick={() => {
                        navigator.clipboard.writeText(record.value)
                        toast.success(<div>Copied Token! <br /> {record.value} </div>, {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        }); 
                    }}>{record.value}</a>
                </Tooltip>
            ),
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            width: 200,
        },
        {
            title: 'Action',
            key: 'action',
            width: 200,
            render: (_, record) => (
                <Space size="middle">
                    <a onClick={() => onDelete(record.id)}>Delete</a>
                </Space>
            ),
        }
    ]

    const onDelete = () => {
        return
    }

    return (<>
        <Table
            rowKey={'id'}
            columns={columns}
            dataSource={data}
        />
    </>)
}

export default TableTokens